app.factory('locationService', ['$q', 'authService', '$http', '$rootScope', function ($q, authService, $http, $rootScope) {
	var service = this;

	service.lastPosition = undefined;

	service.useFakeLocation = false;
	service.fakeLocation = { lng: 12.5706879 + 0.00091, lat: 55.6733068 } ; // near DgT
	service.running = false;

	service.ensureRunning = function() {
		return $q(function(resolve, reject) {
			if (service.running) {
				resolve();
				return;
			}
			window.exo.performOperation('Exo.Location.ListenForLocationUpdates').then(function() {
				console.log('locationService: initialized');
				window.exo.addBroadcastListener(function(name, args) {
					if (name == 'Exo.Location.LocationUpdate') {
						service.onLocationUpdated(args.position);
					}
				});
				service.running = true;
				resolve();
			}, function(err) {
				console.log('locationService: failed to initialize: ' + err);
				reject(err);
			});
		});
	}

	service.forceSyncLocation = function() {
		var loc = service.getLocation();
		if (loc == null) {
			console.log("locationService: forceSyncLocation failed (is null)");
			return;
		}

		// Convert loc to the expected format.
		var exoPosition = {
			latitude: loc.lat,
			longitude: loc.lng
		};

		service.onLocationUpdated(exoPosition);
	}

	service.onLocationUpdated = function(exoPosition) {
		console.log("locationService: location updated!");
		service.lastPosition = { lat: exoPosition.latitude, lng: exoPosition.longitude };

		var pos = service.lastPosition;
		authService.isAuthenticated().then(function(authStatus) {
			if (!authStatus) {
				console.log("locationService: not yet authenticated... delaying...");
				return;
			}

			$http.put('/api/game/locationstate', {
				lastLocation: [pos.lng, pos.lat],
				lastLocationUpdateTime: parseInt((new Date()).getTime() / 1000.0)
			});
		});
	}

	service.getLocation = function() {
		if (!service.running) {
			return null;
		}

		if (service.useFakeLocation) {
			console.log("locationService#getLocation: returning fake location: lat " + service.fakeLocation.lat + ", lng " + service.fakeLocation.lng);
			return service.fakeLocation;
		}

		// XXX: add timer?
		if (service.lastPosition === undefined) {
			return null;
		}

		return service.lastPosition;
	}

	// Stolen from https://stackoverflow.com/questions/27928/calculate-distance-between-two-latitude-longitude-points-haversine-formula
	service.distanceInKM = function(pos1, pos2) {
		function deg2rad(deg) {
 			return deg * (Math.PI / 180);
		}

		var R = 6371.0; // Radius of the earth in km
		var dLat = deg2rad(pos2.lat - pos1.lat);
		var dLon = deg2rad(pos2.lng - pos2.lng);
		var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
		        Math.cos(deg2rad(pos1.lat)) * Math.cos(deg2rad(pos2.lat)) * 
		        Math.sin(dLon/2) * Math.sin(dLon/2);
		var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
		var d = R * c; // Distance in km
		return d;
	}

	$rootScope.$on('authServiceIsAuthenticated', function() {
		service.forceSyncLocation();
	});

	return service;
}]);